import { FormikProps, getIn } from "formik";
import _ from "lodash";

import Stack from "components/Stack";
import TextField from "components/TextField";

import { IFormikParticipant } from "entities/CompanyItegrations/components/Downhome/BusinessForm";
import ListFieldActions from "entities/CompanyItegrations/components/Downhome/BusinessForm/ListFieldActions";

export interface IEmail {
  formik: FormikProps<IFormikParticipant>;
  onRemove: ({ index }: { index: number }) => void;
  onUpdatePrimary: ({ index }: { index: number }) => void;
}

const Email = ({ formik, onRemove, onUpdatePrimary }: IEmail) => (
  <>
    {formik.values.emails?.map((email, index) => {
      const formikKey = `emails.${index}.address`;

      return (
        <Stack
          key={index}
          direction="row"
          spacing={1}
          alignItems="start"
          width="100%"
        >
          <TextField
            sx={{ flexBasis: "50%" }}
            label="Email"
            InputLabelProps={{ shrink: true }}
            {...formik.getFieldProps(formikKey)}
            helperText={
              getIn(formik.touched, formikKey) &&
              getIn(formik.errors, formikKey)
            }
            error={
              getIn(formik.touched, formikKey) &&
              !_.isEmpty(getIn(formik.errors, formikKey))
            }
          />
          <ListFieldActions
            key={index}
            checked={email.primary}
            onPrimaryElementUpdate={() => onUpdatePrimary({ index })}
            onElementRemove={() => onRemove({ index })}
          />
        </Stack>
      );
    })}
  </>
);

export default Email;
